import React from 'react';

const PaymentMethod = () => {
  return (
    <div className="mt-1">
      <p className="text-xs text-gray-600 mb-4">All transactions are secure and encrypted.</p>

      <div className="p-6 rounded-lg border border-[#D3756B]">
        <div className="flex items-center gap-3 border rounded-md p-3 mb-4 bg-white">
          <input type="radio" checked readOnly className="accent-[#65000B]" />
          <div>
            <p className="text-sm text-[#65000B] font-medium mb-1">
              Razorpay Secure (UPI, Cards, Wallets, NetBanking)
            </p>
            <div className="flex items-center gap-2 mt-1">
              {/* ✅ Use HTTPS URLs for security */}
              <img
                src="https://res.cloudinary.com/dzzhbgbnp/image/upload/v1744194466/upi_tg3kzr.webp"
                alt="UPI"
                className="w-7 h-auto"
              />
              <img
                src="https://res.cloudinary.com/dzzhbgbnp/image/upload/v1744194816/Visa-Logo-2014-present_s2h5hx.jpg"
                alt="Visa"
                className="w-7 h-auto"
              />
              <img
                src="https://res.cloudinary.com/dzzhbgbnp/image/upload/v1744194818/Mastercard-Logo_ym5nyw.png"
                alt="Mastercard"
                className="w-7 h-auto"
              />
              <div className="text-xs bg-gray-200 text-gray-600 rounded px-1.5 py-0.5">+17</div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 text-xs text-gray-600 border-t pt-3">
          <span>
            After clicking "Place Order", you will be redirected to Razorpay Secure (UPI, Cards,
            Wallets, NetBanking) to complete your purchase securely.
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
